import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "post-detail-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "确定要删除这篇文章吗？", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "首页"),
  /*#__PURE__*/_createTextVNode("/"),
  /*#__PURE__*/_createElementVNode("span", null, "专栏首页"),
  /*#__PURE__*/_createTextVNode("/"),
  /*#__PURE__*/_createElementVNode("span", null, "学英语是靠刷一百道题还是看一百部电影?")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "w-75 mx-auto mb-5 pb-3"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "user-profile-component border-top border-bottom py-3 mb-5 align-items-center row g-0" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "text-muted col text-right font-italic" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "btn-group mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_user_profile = _resolveComponent("user-profile")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_modal, {
      title: "删除文章",
      visible: _ctx.modalIsVisible,
      onModalOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalIsVisible = false)),
      onModalOnConfirm: _ctx.hideAndDelete
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["visible", "onModalOnConfirm"]),
    _hoisted_3,
    (_ctx.currentPost)
      ? (_openBlock(), _createElementBlock("article", _hoisted_4, [
          (_ctx.currentImageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.currentImageUrl,
                alt: "currentPost.title",
                class: "rounded-lg img-fluid my-4"
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.currentPost.title), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (typeof _ctx.currentPost.author === 'object')
                ? (_openBlock(), _createBlock(_component_user_profile, {
                    key: 0,
                    user: _ctx.currentPost.author
                  }, null, 8, ["user"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_9, "发表于：" + _toDisplayString(_ctx.currentPost.createdAt), 1)
          ]),
          _createElementVNode("div", { innerHTML: _ctx.currentHtml }, null, 8, _hoisted_10),
          (_ctx.showEditArea)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: {name:'createPost', query: { id: _ctx.currentPost._id}},
                  type: "button",
                  class: "btn btn-success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 编辑 ")
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.modalIsVisible = true), ["prevent"]))
                }, "删除")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}